import { render, staticRenderFns } from "./screen_facturaciongeneral.vue?vue&type=template&id=33a0f35e&scoped=true"
import script from "./screen_facturaciongeneral.vue?vue&type=script&lang=js"
export * from "./screen_facturaciongeneral.vue?vue&type=script&lang=js"
import style0 from "./screen_facturaciongeneral.vue?vue&type=style&index=0&id=33a0f35e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a0f35e",
  null
  
)

export default component.exports